export const viewsEs = {
  playersSelection: {
    title: 'Jugadores',
    info: 'Seleccione una competición para ver sus jugadores',
    buttonCompetition: 'Ver jugadores'
  },
  playersIndex:{
    title: 'Jugadores',
    subtitle: 'Jugadores de la competición',
    info: 'Seleccione una competición para ver sus jugadores',
    searchLabel: 'Buscar Jugador',
    tableHeadText: {
      name: 'Nombre',
      fullname: 'Nombre completo',
      country: 'País',
      height: 'Altura',
      weight: 'Peso',
      role: 'Posición',
      team: 'Equipo'
    },
    cardstableText: 'Ver como Tabla/Tarjetas',
    confirmationDialog: {
      bulk: {
        title: 'Confirmar',
        description: 'Por favor, confirme la acción de bulk.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
  },
  teamsSelection: {
    title: 'Equipos',
    info: 'Seleccione una competición para ver sus equipos',
    buttonTeam: 'Ver equipos'
  },
  teamsIndex: {
    title: 'Equipos',
    subtitle: 'Equipos de la competición',
    info: 'Seleccione una competición para ver sus equipos',
    filter: {
      team: 'Equipo',
      search: 'Buscar Equipo'
    },
    tableHeadText: {
      name: 'Nombre',
      short: 'Abreviatura',
      country: 'País',
      venue: 'Estadio',
      players: 'Jugadores',
      button: 'Ver Jugadores',
      playerTitle: 'Jugadores del ',
      playerName: 'Nombre',
      playerRole: 'Posición'
    },
    cardstableText: 'Ver como Tabla/Tarjetas',
    confirmationDialog: {
      bulk: {
        title: 'Confirmar',
        description: 'Por favor, confirme la acción de bulk.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
  },
  matchesSelection: {
    title: 'Partidos',
    info: 'Seleccione una competición para ver sus partidos',
    buttonCompetition: 'Ver Partidos'
  },
  matchesIndex:{
    title: 'Partidos',
    subtitle: 'Partidos de la competición',
    info: 'Seleccione una competición para ver sus partidos',
    tableHeads: {
      matchday: 'Nº Jornada',
      hometeam: 'Equipo Local',
      score: 'Marcador',
      awayteam: 'Equipo Visitante',
      startdate: 'Fecha de arranque',
      type: 'Tipo',
      status: 'Estados',
      load: 'Cargar',
    },
    filter: {
      matchday: 'Nº Jornada',
      homeTeam: 'Equipo Local',
      awayTeam:'Equipo Visitante',
      status: 'Estados'
    },
    confirmationDialog: {
      bulk: {
        title: 'Confirmar',
        description: 'Por favor, confirme la acción de bulk.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
  },
  matchsetsIndex: {
    title: 'Jornadas',
    closed:'Cerrado',
    infoButton:'Ver info',
    filter: {
      name: 'Buscar por Nombre',
      sport: 'Deporte',
      status: 'Estados'
    },
    tableHeadText: {
      public: 'Público',
      name: 'Nombre',
      sport: 'Deporte',
      status: 'Estados',
      createdBy: 'Creado por',
      startdate: 'Fecha de arranque',
      enddate: 'Fecha de fin',
      options: 'Opciones',
      load: 'Cargar'
    },
    actions:{
      open:'Abrir',
      close:'Cerrar'
    },
    buttonInfo: 'Ver información',
    confirmationDialog: {
      reload: {
        title: 'Confirmar',
        description: 'Por favor, confirme la acción de reload.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
      public: {
        title: 'Confirmar',
        description: 'Por favor, confirme el cambio de público.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
      actions: {
        title: 'Confirmar',
        description: 'Por favor, confirme la acción.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
  },
  contestsIndex:{
    title: 'Campeonatos',
    filter: {
      name: 'Buscar por nombre',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      status: 'Estado',
    },
    tableHeadText: {
      name: 'Nompre',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      status: 'Estado',
      sport: 'Deporte',
      options: 'Opciones'
    },
    actions:{
      open:'Abrir',
      close:'Cerrar',
      finish:'Finalizar',
      score:'Puntos',
      winners:'Establecer Ganadores',
      abandom: 'Abandonar',
      suspen: 'Suspender',
    },
    confirmationDialog: {
      actions: {
        title: 'Confirmar',
        description: 'Por favor, confirme la acción.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
  },
  competitionsIndex:{
    title: 'Competiciones',
    buttonMatches: 'Ver partidos',
    buttonTeams: 'Ver Equipos',
    tableHeadText: {
      name: 'Nombre',
      sport: 'Deporte',
      status: 'Estado',
      country: 'País',
      season: 'Temporada',
    },
    confirmationDialog: {
      status: {
        title: 'Confirmar',
        description: 'Por favor, confirme el cambio de estado.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
  },
  networksIndex:{
    title: 'Networks',
    tableHeadText: {
      name: 'Name',
      fee: 'Fee',
      organizer:'Organizer',
      jurisdiction: 'Jurisdicción',
      disabled:'Disabled'
    },
    status:{
      enabled:'Activado',
      disabled:'Desactivado'
    },
    button:'See Info',
    confirmationDialog: {
      status: {
        title: 'Confirmar',
        description: 'Por favor, confirme el cambio de estado.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
  },
  providersIndex:{
    title: 'Proveedores',
    tableHeadText: {
      name: 'Nombre',
      key: 'Clave',
      status:'Estado'
    },
    confirmationDialog: {
      status: {
        title: 'Confirmar',
        description: 'Por favor, confirme el cambio de estado.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
    dialog: {
      iplist: {
        button: 'Lista de IPS',
        title: 'Lista de IPS: ',
      }
    },
    status:{
      enabled:'Activado',
      disabled:'Desactivado'
    },
    button:'Ver Info'
  },
  operatorsIndex:{
    title:'Operadores',
    tableHeadText: {
      name: 'Nombre',
      code: 'Código',
      connector:'Conector',
      jurisdiction:'Jurisdicción',
      host:'Host',
      status:'Estado'
    },
    confirmationDialog: {
      status: {
        title: 'Confirmar',
        description: 'Por favor, confirme el cambio de estado.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
    dialog: {
      details: {
        button: 'Resumen',
        title: 'Resumen: ',
        labels: {
          name: 'Nombre',
          id: 'Código',
          connector: 'Connector',
          key: 'Clave',
          connectorId: 'ConnectorId',
          connectorKey: 'ConnectorKey',
          jurisdiction: 'Jurisdicción',
          status: 'Estado',
          casinoApi: 'CasinoApi',
          sportsApi: 'SportsApi',
          bonusApi: 'BonusApi',
          disabled: 'Habilitado',
          retail: 'Retail',
          invoice: 'Invoice',
          url: {
            lobby: 'Lobby',
            cashier: 'Cashier',
            virtualsports: 'Virtualsports',
            sportsbook: 'Sportsbook',
          },
          cfg: {
            cl: 'cl',
            oi: 'oi',
            raf: 'raf',
            rafpct: 'rafpct',
          },
          sms: {
            enabled: 'Habilitado',
            origin: 'Origin',
            user: 'Usuario',
          },
        },
      },
      iplist: {
        button: 'Lista de IPS',
        title: 'Lista de IPS: ',
        // labels: {
        //   name: 'Name',
        //   id: 'Code',
        //   connector: 'Connector',
        //   key: 'Key',
        //   host: 'Host',
        // },
      },
      providers: {
        expandButton: 'Proveedores',
      },
    },
    status:{
      enabled:'Activado',
      disabled:'Desactivado'
    },
    key:'Clave',
    licenses:'Licencias',
    button: 'Ver info',
    emptyProviders: 'Este operador no tiene proveedores asociados',
  },
  usersIndex:{
    title:'Usuarios',
    filter: {
      name: 'Filtros',
      operator: 'Operador',
      start: 'Desde',
      end: 'Hasta',
      send: 'Filtrar',
    },
    tableHeadText: {
      operator: 'Operator',
      id: 'ID',
      username:'Usuario',
      registrationDate:'Fecha alta',
      lastTransaction:'Fecha ultima transaccion',
      currency:'Divisa'
    },
    button: 'Ver info',
  },
  usersInfo:{
    title:'Info de',
    tableHeadText: {
      date: 'Fecha',
      gameId: 'Id del juego',
      quantity:'Cantidad',
      transactionType:'Tipo de transacción'
    },
    button: 'Ver log',
  },
  gamesIndex:{
    title: 'Juegos',
    filter:{
      provider: 'Proveedor',
      jurisdiction: 'Jurisdicción',
      license: 'Licencia',
    },
    tableHeadText: {
      name: 'Nombre',
      alias: 'Alias',
      type:'Tipo',
      status:'Estado',
      provider:'Proveedor',
      key:'Launch ID'
    },
    confirmationDialog: {
      status: {
        title: 'Confirmar',
        description: '¿Estas seguro que quieres desactivar este juego?.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
    status:{
      enabled:'Activado',
      disabled:'Desactivado'
    },
    button: 'Ver info',
  },
  roundsIndex:{
    title:'Rounds',
    filter: {
      name: 'Filtros',
      operator: 'Operador',
      provider: 'Proveedor',
      game: 'Juego',
      start: 'Desde',
      end: 'Hasta',
      send: 'Filtrar',
    },
    tableHeadText: {
      roundId: 'Round ID',
      operator: 'Operador',
      provider:'Proveedor',
      game:'Juegos',
      moneyIn:'Dinero In',
      moneyOut:'Dinero Out',
      user:'Usuario',
      status:'Estado',
      start:'Comienzo'
    },
    confirmationDialog: {
      status: {
        title: 'Confirmar',
        description: 'Por favor, confirme el cambio de estado.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
    status:{
      enabled:'Enabled',
      disabled:'Disabled'
    },
    button: 'Ver info',
  },
  adminIndex:{
    title: 'Administradores',
    tableHeadText: {
      name: 'Nombre',
      email: 'Email',
      rol: 'Rol'
    },
    button: 'Ver info',
  },
  dashboardIndex:{
    dashboard:'Inicio',
    economicSection: 'Sección Económica',
    usersSection: 'Sección de Usuarios',
    gamesSection: 'Sección de Juegos',
    playersSection: 'Sección de Jugadores',
    providersSection: 'Sección de Proveedores',
    operatorsSection: 'Sección de Operadores',
    chars:{
      revenue:'Ingresos',
      moneinout:'Dinero In/Out',
      registeredUsers:'Usuarios Registrados'
    },
    dateToggle:{
      week:'7 días',
      month:'30 dias',
      year:'1 año',
      twoyears:'2 años',
      custom:'Personalizada'
    },
    sections:{
      topRevenue: 'Top Ingresos',
      topLoss: 'Top Perdidas',
      topWinners: 'Top Ganadores',
      topLosers: 'Top Perdedores'
    },
  },
  categoriesIndex:{
    title: 'Categorías',
    tableHead: {
      name: 'Nombre',
      sport: 'Deporte',
      country: 'País',
    },
  },
  rtpIndex:{
    title:'RTP',
    filter: {
      name: 'Filtros',
      operator: 'Operador',
      month: 'Seleccione mes',
      send: 'Filtrar',
    },
    tableHead: {
      name: 'Proveedor',
      game: 'Juego',
      teoricRtp: 'Teoric RTP',
      desktopRtp: 'RTP Desktop',
      mobileRtp: 'RTP Mobile',
    },
    button: {
      downloadcsv: 'Descargar CSV',
    }
  },
  freespinsIndex: {
    title: 'Freespins',
    confirmationDialog: {
      status: {
        title: 'Confirmar',
        description: 'Por favor, confirme el cambio de estado.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
  },
  lobbyIndex: {
    title: 'Lobby',
    tableHead: {
      operator: 'Operador',
      name: 'Nombre',
      ncategories: 'Número de categorías',
      ngames: 'Número de juegos',
    },
  },
  freeroundsIndex: {
    title: 'Campañas',
    confirmationDialog: {
      status: {
        title: 'Confirmar',
        description: 'Por favor, confirme el cambio de estado.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
  },
};
